/**
 * Team member types to use in Sphere Dashboard
 * The property "role" is to defined here because "role" is required in company member type
 */

/** Base props for a team */

/**
 * This type covers all team types returned from different routes
 * The purpose of it is to remove the confusion between all these types
 */

/** Available team sort fields - derived from TEAMS_SORTABLE_FIELDS */

/** Sortable column fields for the teams table */
export const TEAMS_SORT_BY = ["name_ascending", "name_descending", "users_ascending", "users_descending", "creation_date_ascending", "creation_date_descending", "workspace_role_ascending", "workspace_role_descending"];

/** All possible teams sort by values */